import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@mui/material';
import AxiosInstance from '../../../server/AxioInstance';
import TableComponent from '../../common/table/Table';

const columns = [
  { id: 'id', label: 'Num. Treinamento', align: 'center' },
  { id: 'title', label: 'Título', align: 'left' },
  { id: 'dt_training', label: 'Data Treinamento', align: 'left' },
  { id: 'instructors_name', label: 'Instrutor', align: 'center' },
  { id: 'button', label: 'Relatório', align: 'center' },
];

export const ReportTrainingDialog = ({ handleCancel, handlexlsx, showSnackbar }) => {
  const [rows, setRows] = useState([]);

  const handleReport = async (item) => {
    showSnackbar('Aguarde relatório sendo gerado ...', 'info');
    try {
      const result = await AxiosInstance.post('/report/report-list-check', item);
      handlexlsx(result.data);
      showSnackbar('Relatório gerado com sucesso', 'success');
    } catch (error) {
      console.log(error);
      showSnackbar(error.message, 'error')
    }

  };

  const ButtonReport = (item) => {
    return (
      <Button variant="contained" color="secondary" onClick={() => handleReport(item)}>
        gerar relatório
      </Button>
    );
  };

  const fetchData = useCallback(async () => {
    const result = await AxiosInstance.get('/report/report-training');
    const temp = (await result.data)
      ? result?.data?.map((item) => ({
        ...item,
        button: <ButtonReport item={item} />,
      }))
      : [];
    setRows(temp);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <DialogTitle>Relatório de lista de resença - Treinamentos</DialogTitle>
      <DialogContent>
        <Box p={2}>
          <TableComponent columns={columns} rows={rows} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="contained" color="error">
          sair
        </Button>
      </DialogActions>
    </>
  );
};
